(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["whalebud-review-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = new WeakMap();

    const prefersReducedMotion = () =>
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const stripCloneAttributes = (element) => {
      if (!element) return;
      [
        'data-whalebud-review-block',
        'data-block-id',
        'data-shopify-editor-block',
        'data-shopify-editor-block-id',
        'data-shopify-editor-block-type',
        'id'
      ].forEach((attribute) => element.removeAttribute(attribute));
      element.setAttribute('aria-hidden', 'true');
      element.setAttribute('tabindex', '-1');
      element.classList.add('whalebud-review-carousel__slide--clone');
      element.querySelectorAll('a, button, input, select, textarea, iframe, video, [tabindex]').forEach((node) => {
        if (node.tagName === 'A' || node.tagName === 'BUTTON' || node.tagName === 'INPUT' || node.tagName === 'SELECT' || node.tagName === 'TEXTAREA' || node.tagName === 'IFRAME' || node.tagName === 'VIDEO') {
          node.setAttribute('tabindex', '-1');
        }
        node.setAttribute('aria-hidden', 'true');
      });
      element.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
    };

    const cloneRowItems = (row, targetCopies) => {
      const originals = Array.from(row.children).filter((child) => !child.classList.contains('whalebud-review-carousel__slide--clone'));
      if (!originals.length) return;
      const existingClones = row.querySelectorAll('.whalebud-review-carousel__slide--clone').length;
      const currentCopies = 1 + Math.floor(existingClones / originals.length);
      for (let copyIndex = currentCopies; copyIndex < targetCopies; copyIndex += 1) {
        originals.forEach((original) => {
          const clone = original.cloneNode(true);
          stripCloneAttributes(clone);
          row.appendChild(clone);
        });
      }
    };

    const resetMarqueeRow = (row) => {
      if (!row) return;
      row.querySelectorAll('.whalebud-review-carousel__slide--clone').forEach((clone) => clone.remove());
      row.style.removeProperty('--whalebud-marquee-duration');
    };

    const setupMarqueeRow = (row, viewport, speedSetting) => {
      if (!row) return;
      const originals = Array.from(row.children).filter((child) => !child.classList.contains('whalebud-review-carousel__slide--clone'));
      if (!originals.length) return;

      const baseWidth = row.scrollWidth;
      if (!baseWidth) return;

      let copies = 1;
      const minWidth = viewport.clientWidth * 2;
      while (row.scrollWidth < minWidth || copies % 2 !== 0) {
        cloneRowItems(row, copies + 1);
        copies += 1;
        if (copies > 8) break;
      }

      const distance = row.scrollWidth / 2;
      const pace = Math.max(3, Math.min(12, Number(speedSetting || 5)));
      const pixelsPerSecond = 18 + (12 - pace) * 5;
      row.style.setProperty('--whalebud-marquee-duration', `${Math.max(12, distance / pixelsPerSecond)}s`);
    };

    const refreshMarquee = (state) => {
      state.rows.forEach(resetMarqueeRow);
      state.root.classList.add('is-marquee');
      state.rows.forEach((row) => setupMarqueeRow(row, state.viewport, state.speedSetting));
    };

    const getStep = (viewport) => {
      const slide = viewport.querySelector('.whalebud-review-carousel__slide');
      if (!slide) return Math.max(280, viewport.clientWidth * 0.75);
      const slideRect = slide.getBoundingClientRect();
      const styles = window.getComputedStyle(slide);
      const margin = parseFloat(styles.marginRight || '0') || 0;
      return Math.max(220, slideRect.width + margin + 16);
    };

    const startMarquee = (state) => {
      if (!state.marqueeEnabled) return;
      refreshMarquee(state);
    };

    const init = (root) => {
      if (!root || roots.has(root)) return;

      const viewport = root.querySelector('.whalebud-review-carousel__viewport');
      if (!viewport) return;

      const state = {
        root,
        viewport,
        rows: Array.from(root.querySelectorAll('.whalebud-review-carousel__row')),
        speedSetting: Number(root.dataset.speed || 5),
        marqueeEnabled: root.dataset.autoplay === 'true' && !prefersReducedMotion(),
        listeners: [],
        resizeObserver: null
      };

      const add = (target, event, handler) => {
        if (!target) return;
        target.addEventListener(event, handler);
        state.listeners.push([target, event, handler]);
      };

      if (!state.marqueeEnabled) {
        add(root.querySelector('[data-whalebud-carousel-prev]'), 'click', () => {
          viewport.scrollBy({ left: -getStep(viewport), behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
        });

        add(root.querySelector('[data-whalebud-carousel-next]'), 'click', () => {
          viewport.scrollBy({ left: getStep(viewport), behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
        });
      } else {
        if (window.ResizeObserver) {
          state.resizeObserver = new ResizeObserver(() => {
            window.requestAnimationFrame(() => refreshMarquee(state));
          });
          state.resizeObserver.observe(viewport);
        }
        window.requestAnimationFrame(() => startMarquee(state));
      }

      roots.set(root, state);
    };

    const destroy = (root) => {
      const state = roots.get(root);
      if (!state) return;
      if (state.resizeObserver) {
        state.resizeObserver.disconnect();
      }
      state.listeners.forEach(([target, event, handler]) => target.removeEventListener(event, handler));
      roots.delete(root);
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-whalebud-review-carousel]').forEach(init);
    };

    document.addEventListener('DOMContentLoaded', () => initAll());
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-whalebud-review-carousel]').forEach(destroy);
    });
    document.addEventListener('shopify:block:select', (event) => {
      const block = event.target.closest('[data-whalebud-review-block]');
      if (!block) return;
      const root = block.closest('[data-whalebud-review-carousel]');
      const state = roots.get(root);
      if (!state) return;
      block.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
    });

    initAll();
  })();

  } catch(e) { console.error(e); }
})();
})();
